import {createSlice} from "@reduxjs/toolkit";

const initialState = {
    loadingFlag:0,
    locationDropdownList: {},
    userTypes: {},
    saveButtonDisabled: false,
    errorMessage: '',
    successMessage: null,
    resetSuccess: null,
    resetError: null
}

export const addUserSlice = createSlice({
    name: 'addUser', initialState,
    reducers: {
        setInitialState: (state, action) => {
            state.resetSuccess = null;
            state.resetError = null;
            state.errorMessage = '';
            state.successMessage = null;
        },
        getLocationDropdownSuccess: (state, action) => {
            state.locationDropdownList = action.payload;
            state.errorMessage = '';
            state.successMessage = null;
        },
        getLocationDropdownError: (state, action) => {
            state.locationDropdownList = {};
            state.errorMessage = action.payload;
            state.successMessage = null;
        },
        getUserTypesSuccess: (state, action) => {
            state.userTypes = action.payload;
            state.errorMessage = '';
            state.successMessage = null;
        },
        getUserTypesError: (state, action) => {
            state.userTypes = {};
            state.errorMessage = action.payload;
            state.successMessage = null;
        },
        updateUserInfoSuccess: (state, action) => {
            if(action.payload === 'add')
                state.successMessage = 'EmployerUser details added successfully';
            else {
                state.successMessage = 'EmployerUser details updated successfully';
            }
            state.errorMessage = '';
        },
        updateUserInfoError: (state, action) => {
            state.successMessage = null;
            state.errorMessage = action.payload;
        },
        forgotPasswordSuccess: (state, action) => {
            state.resetSuccess = action.payload;
            state.resetError = null;
        },
        forgotPasswordError: (state, action) => {
            state.resetSuccess = null;
            state.resetError = action.payload;
        },
        resetPasswordSuccess: (state, action) => {
            state.resetSuccess = action.payload;
            state.resetError = null;
        },
        resetPasswordError: (state, action) => {
            state.resetSuccess = null;
            state.resetError = action.payload;
        },
        setSaveButtonDisabled: (state,action) => {
            state.saveButtonDisabled = action.payload
        },
        setLoadingFlagIncrement:state => {
            state.loadingFlag = state.loadingFlag + 1
        },
        setLoadingFlagDecrement: state => {
            if (state.loadingFlag !== 0) {
                state.loadingFlag = state.loadingFlag - 1
            }
        }
    }
});
export const {
    setInitialState,
    getLocationDropdownSuccess,
    getLocationDropdownError,
    getUserTypesSuccess,
    getUserTypesError,
    updateUserInfoSuccess,
    updateUserInfoError,
    forgotPasswordSuccess,
    forgotPasswordError,
    resetPasswordSuccess,
    resetPasswordError,
    setSaveButtonDisabled,
    setLoadingFlagIncrement,
    setLoadingFlagDecrement
} = addUserSlice.actions;

export default addUserSlice.reducer;